import React, {useCallback, useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import {useModal} from "../../contexts/ModalContext";
import TitleSecondary from "../../components/Title/TitleSecondary";
import {useUser} from "../../contexts/UserContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faEraser, faExternalLink,
} from "@fortawesome/free-solid-svg-icons";
import {
    getStatsMainPage,
} from "../../services/StatsService";
import MyDonut from "../../components/Charts/MyDonut";
import StrokeContainer from "../../components/Container/StrokeContainer";
import EmployeesSexeChart from "../../components/Charts/EmployeesSexeChart";
import MyPie from "../../components/Charts/MyPie";
import EmployeesAgeChart from "../../components/Charts/EmployeesAgeChart";
import SearchEntreprise from "../../components/Search/SearchEntreprise";
import styles_field from "../../components/Field/Field.module.css";
import Routing from "../../services/routing";
import DateService from "../../services/DateService";
import useDateFilter from "../../hooks/MainStatsPage";
import {isAdmin} from "../../services/RoleService";

function MainStatsPage() {
    const [activitesParticipationSalaries, setActivitesParticipationSalaries] = useState(null);
    const [pratiquantsSalaries, setPratiquantsSalaries] = useState(null);
    const [participationSalariesParSexe, setParticipationSalariesParSexe] = useState(null);
    const [participationSalariesParAge, setParticipationSalariesParAge] = useState(null);
    const [actifsSurSalaries, setActifsSurSalaries] = useState(null);
    const [actifsSurSalariesBrutData, setActifsSurSalariesBrutData] = useState(null);
    const { user } = useUser();
    const { showModal } = useModal();
    const location = useLocation();
    const navigate = useNavigate();
    const now = DateService.formatDateWithoutTime(new Date());
    const threeMonthsAgo = DateService.subtractMonths(3);
    const statActiviteTypeUrl = `/stats/activite_types?filter_date=${threeMonthsAgo}%2C${now}`;
    const params = new URLSearchParams(location.search);
    const { startDate, endDate, handleDateChange, removeDateFilter } = useDateFilter();
    const [startDateFilter, setStartDateFilter] = useState(startDate);
    const [endDateFilter, setEndDateFilter] = useState(endDate);
    const [mainTitle, setMainTitle] = useState("STATISTIQUES");

    const handleSuccess = useCallback((message = "Statistiques récupérées") => {
        showModal('success', { children: message, timeout: 1500 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 1500 });
    }, [showModal]);

    const renderActivitesParticipation = () => {
        if (activitesParticipationSalaries) {
            return <MyDonut data={activitesParticipationSalaries.activities} title={"Participants"} totalValue={activitesParticipationSalaries.totalUsers}/>;
        } else {
            return <p>Pas de données</p>;
        }
    }

    const renderPratiquants = () => {
        if (activitesParticipationSalaries && activitesParticipationSalaries.length > 0 && activitesParticipationSalaries[0].length > 0) {
            return activitesParticipationSalaries.map((myStat, index) => <MyPie key={index} data={myStat} title={"Participants"}/>);
        } else {
            return <p>Pas de données</p>;
        }
    }

    const renderParticipationSalariesParSexe = () => {
        if (participationSalariesParSexe && participationSalariesParSexe.length > 0 && participationSalariesParSexe[0].length > 0) {
            return participationSalariesParSexe.map((myStat, index) => <StrokeContainer stroke={false} key={index} title={"Salariés actifs:"} children={<EmployeesSexeChart data={myStat} />} />);
        } else {
            return <p>Pas de données</p>;
        }
    }

    const renderParticipationSalariesParAge = () => {
        if (participationSalariesParAge && participationSalariesParAge.length > 0) {
            return <StrokeContainer stroke={false} title={"Salariés actifs:"} children={<EmployeesAgeChart data={participationSalariesParAge} />} />;
        } else {
            return <p>Pas de données</p>;
        }
    }

    const renderActifsSurSalaries = () => {
        if (actifsSurSalariesBrutData && actifsSurSalariesBrutData.total > 0) {
            return actifsSurSalaries.map((myStat, index) => <MyDonut key={index} data={myStat} title={"Salariés"}/>);
        } else {
            return <p>Pas de données</p>;
        }
    }

    const updateURLParamsEntreprise = (entr) => {
        params.set("filter_entreprise", entr.entrepriseId);
        navigate({ pathname: location.pathname, search: params.toString() });
    };

    const updateURLParamsDates = (start, end) => {
        params.set("filter_start", start);
        params.set("filter_end", end);

        navigate({ pathname: location.pathname, search: params.toString() });
    };

    const removeFilterDates = () => {
        params.delete("filter_start");
        params.delete("filter_end");

        navigate({ pathname: location.pathname, search: params.toString() });
    }

    useEffect( () => {
        if (!user) return;

        const fetchData = async () => {
            if (location.pathname === "/stats/mois") {
                const filterStartDate = DateService.getStartOfPreviousMonth();
                const filterEndDate = DateService.getEndOfPreviousMonth();
                setStartDateFilter(filterStartDate);
                setEndDateFilter(filterEndDate);

                params.set("filter_start", filterStartDate);
                params.set("filter_end", filterEndDate);
                setMainTitle("STATISTIQUES DU MOIS");
            }

            if (isAdmin(user) && !params.get("filter_entreprise")) {
                return;
            }

            const rez = await getStatsMainPage(params.toString());
            if (rez.success === true || rez.success === "true") {
                // Mettre à jour les champs start et end avec rez.data.start et rez.data.end
                const start = rez.data.start && DateService.formatDate(rez.data.start);
                const end = rez.data.end && DateService.formatDate(rez.data.end);

                if (rez.data?.activitesParticipationSalaries) {
                    setActivitesParticipationSalaries(rez.data.activitesParticipationSalaries);
                } else {
                    console.warn("Pas de données pour les activités");
                    setActivitesParticipationSalaries([]);
                    handleError("Pas de données pour les activités");
                }

                if (rez.data?.participantsSalaries) {
                    setPratiquantsSalaries(rez.data.participantsSalaries);
                } else {
                    console.warn("Pas de données pour les activités");
                    setPratiquantsSalaries([]);
                    handleError("Pas de données pour les activités");
                }

                if (rez.data?.actifsSurSalariesBrutData) {
                    setActifsSurSalariesBrutData(rez.data.actifsSurSalariesBrutData);
                } else {
                    console.warn("Pas de données pour les actifs sur salariés");
                    setActifsSurSalariesBrutData([]);
                    handleError("Pas de données pour les actifs sur salariés");
                }

                if (rez.data?.participationSalariesParSexe) {
                    setParticipationSalariesParSexe(rez.data.participationSalariesParSexe);
                } else {
                    console.warn("Pas de données pour les salariés");
                    setParticipationSalariesParSexe([]);
                    handleError("Pas de données pour les salariés");
                }

                if (rez.data?.participationSalariesParAge) {
                    setParticipationSalariesParAge(rez.data.participationSalariesParAge);
                } else {
                    console.warn("Pas de données pour les salariés");
                    setParticipationSalariesParAge([]);
                    handleError("Pas de données pour les salariés");
                }

                if (rez.data?.actifsSurSalaries) {
                    setActifsSurSalaries(rez.data.actifsSurSalaries);
                } else {
                    console.warn("Pas de données pour les actifs sur salariés");
                    setActifsSurSalaries([]);
                    handleError("Pas de données pour les actifs sur salariés");
                }
            } else {
                handleError(rez.message);
            }
        }
        fetchData();
    }, [user, location]);

    return (
        <>
            <div className="content">
                <TitleMain text={mainTitle}/>

                <div className={"navLink"}
                     style={{
                         display: "flex",
                         flexDirection: "row",
                         gap: "12px",
                         marginBottom: "24px",
                         flexWrap: "wrap",
                         justifyContent: "center"
                     }}>

                    {// TODO en mobile aligne sur uen colonne
                        location.pathname === Routing.routes.statsMois ?
                        <Link to={Routing.routes.statsMain + location.search}><FontAwesomeIcon icon={faExternalLink}/> Statistiques globales</Link> :
                        <Link to={Routing.routes.statsMois +location.search}><FontAwesomeIcon icon={faExternalLink}/> Statistiques du mois</Link>}
                    <Link to={Routing.routes.statsUsers}><FontAwesomeIcon icon={faExternalLink}/> Statistiques utilisateurs</Link>
                    <Link to={statActiviteTypeUrl ?? Routing.routes.statsActiviteTypes}><FontAwesomeIcon icon={faExternalLink}/> Statistiques activités</Link>

                    { location.pathname === Routing.routes.statsMois && startDateFilter && endDateFilter && <span style={{
                        fontSize: "14px",
                        color: "#3c3c3c",
                        fontStyle: "italic",
                        margin: "12px 0"
                    }}>
                        Données du {DateService.formatFrenchDateWithoutTime(startDateFilter)} au {DateService.formatFrenchDateWithoutTime(endDateFilter)}
                    </span>}
                </div>

                {(location.pathname === Routing.routes.statsMain || location.pathname === Routing.routes.stats) &&
                    <div style={{border: "1px solid var(--clr-accent)", padding: "16px", color: "var(--clr-font)", margin: "16px 0", width: "100%", maxWidth: "400px"}}>
                        <span>Plage de dates personnalisées</span>
                        <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", justifyContent: "center", gap: "8px", margin: "6px 0"}}>
                            <div className={styles_field.field}>
                                <input
                                    type="date"
                                    value={startDateFilter}
                                    onChange={(e) => setStartDateFilter(e.target.value)}
                                />
                            </div>

                            <div className={styles_field.field}>
                                <input
                                    type="date"
                                    value={endDateFilter}
                                    onChange={(e) => setEndDateFilter(e.target.value)}
                                />
                            </div>

                            <button className={"btn_icon"} onClick={() => {
                                removeDateFilter();
                                setStartDateFilter("");
                                setEndDateFilter("");
                            }}>
                                <FontAwesomeIcon icon={faEraser}/>
                            </button>

                            <button className={"btn btn_success"} onClick={() => {
                                updateURLParamsDates(startDateFilter, endDateFilter);
                            }}>
                                Appliquer
                            </button>
                        </div>
                    </div>
                }

                {// TODO afficher l'entreprise selectionnée
                    user && (user.roles.includes("ROLE_ADMIN") || user.roles.includes("ROLE_SUPER_ADMIN")) &&
                    <div style={{border: "1px solid var(--clr-accent)", padding: "16px", color: "var(--clr-font)", margin: "16px 0", width: "100%", maxWidth: "400px"}}>
                        <span>Entreprise</span>
                        <SearchEntreprise onSubmit={updateURLParamsEntreprise}/>
                    </div>}
            </div>

            <div className={"content"}>
            <TitleSecondary text={"Participants par type d'activité"}/>

                {renderActivitesParticipation()}
            </div>

            <div className={"content"}>
                <TitleSecondary text={"Pourcentage d'actifs par rapport au total salarié"}/>

                {renderActifsSurSalaries()}
            </div>

            {/*
                <div className={"chartsContainer"}>
                    <TitleSecondary text={"Pourcentage de pratiquants"}/>

                    {renderPratiquants()}
                </div>
            */
            }

            <div className={"content"}>
                <TitleSecondary text={"Salariés actifs par sexe"}/>

                {renderParticipationSalariesParSexe()}
            </div>

            <div className={"content"}>
                <TitleSecondary text={"Salariés actifs par tranche d'âge"}/>
                <p style={{ fontSize: "0.8rem", color: "#555" }}>Valide uniquement pour les salariés ayant renseigné leur date de naissance. Les tranches d'âge sans actifs sont masquées.</p>

                {renderParticipationSalariesParAge()}
            </div>
        </>
    )
}

export default MainStatsPage;
